import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, NgModule, Output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ScrollToModule } from '@nicky-lenaers/ngx-scroll-to';
import { AosModule, ImaginarySrcModule } from '@wizbii/angular-utilities';
import { trackEventWithAtInternet } from '@wizbii/tracking';

interface CejBenefitCondition {
  id: string;
  emphasis?: string;
  text?: string;
}
@Component({
  selector: 'app-cej-v2-can-i-benefit',
  templateUrl: './cej-v2-can-i-benefit.component.html',
  styleUrls: ['./cej-v2-can-i-benefit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CejV2CanIBenefitComponent {
  @Output() clickButton: EventEmitter<void> = new EventEmitter();

  conditions: CejBenefitCondition[] = [
    {
      id: '1',
      emphasis: "J'ai entre 16 et 25 ans",
      text: '(moins de 30 ans si je suis en situation de handicap)',
    },
    {
      id: '2',
      emphasis: 'Je suis sans emploi, ni formation',
    },
    {
      id: '2',
      emphasis: "Je n'ai pas de projet professionnel défini",
      text: "et j'ai perdu confiance en moi",
    },
    {
      id: '3',
      emphasis: 'Je fais face à des difficultés matérielles et financières',
    },
    {
      id: '4',
      emphasis: "Je suis prêt(e) à m'engager",
      text: 'à suivre le programme',
    },
  ];

  buttonClicked(): void {
    this.trackEvent();
    this.clickButton.emit();
  }

  private trackEvent(): void {
    trackEventWithAtInternet({
      category: 'CEJ',
      action: 'Click Je me lance',
      label: 'middle',
      type: 'action',
    });
  }

  trackByConditionId(_: number, condition: CejBenefitCondition): string {
    return condition.id;
  }
}

@NgModule({
  imports: [CommonModule, ImaginarySrcModule, MatIconModule, ScrollToModule, AosModule],
  declarations: [CejV2CanIBenefitComponent],
  exports: [CejV2CanIBenefitComponent],
})
export class CejV2CanIBenefitModule {}
